import { AbstractControl, ValidationErrors } from '@angular/forms';

import { SpecialValidationType } from '@app/origami-api/constants/validation-type';
import { SpecialValidatorFnFactory } from '@app/shared/utils/special-validators/special-validators.model';

export const createDenyFutureDatesValidator: SpecialValidatorFnFactory = function () {
  return function (control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const result = !(value && new Date(value) > new Date());

    return result ? null : { [SpecialValidationType.DenyFutureDates]: { value } };
  };
};
